import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CommonService } from 'wire-frame';

import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class InventoryService {

  private apiUrl: string;

  constructor(private http: HttpClient, private common: CommonService, private apiService: ApiService) { 
    this.apiUrl = this.apiService.getBaseUrl();
  }

  private getAuthHeaders() {
    const token = localStorage.getItem('jwtToken');
    return {
      headers: new HttpHeaders({
        'Authorization' : `Bearer ${token}`
      })
    }
  }

  // getMedicines(){ return this.http.get(this.apiUrl + `/inventory/stock`,this.getAuthHeaders()); }

  getMedicines(params:any){
    return this.http.get(
      this.apiUrl + `/inventory/stock`,
      { params, ...this.getAuthHeaders() }
    );
  }

  addToWarehouse(data:any){ return this.http.post(this.apiUrl + `/inventory/add`,data,this.getAuthHeaders()); }
  supplyToClinic(data:any){ return this.http.post(this.apiUrl + `/inventory/supply`,data,this.getAuthHeaders()); }
  getHistory(id:number){ return this.http.get(this.apiUrl + `/inventory/history/${id}`,this.getAuthHeaders()); }
}
